import { ActionContext } from "vuex";

import { PREFIX_ID } from "@/constants";
import IState from "@/interfaces/IState";
import ITrafficSource from "@/interfaces/ITrafficSource";

export default async (
  context: ActionContext<IState, IState>,
  ids: string[]
) => {
  try {
    const dependencies: Array<Promise<ITrafficSource>> = [];
    let pendingSubscriptionTrafficSources: {
      [key: string]: Promise<ITrafficSource>;
    } = { ...context.rootState.pendingRequests.subscriptionTrafficSources };

    ids.forEach((id) => {
      if (!context.rootState.trafficSources[`${PREFIX_ID}${id}`]) {
        if (!pendingSubscriptionTrafficSources[id]) {
          pendingSubscriptionTrafficSources[id] = context.dispatch("subscriptionsGetTrafficSource", id, {
            root: true,
          });
        }

        dependencies.push(pendingSubscriptionTrafficSources[id]);
      }
    });

    if (dependencies.length > 0) {
      context.commit("setPendingRequests", {
        ...context.rootState.pendingRequests,
        subscriptionTrafficSources: pendingSubscriptionTrafficSources,
      });

      const data = await Promise.all(dependencies);
      const subscriptionTrafficSources = data.concat(
        context.rootGetters.subscriptionsGetTrafficSources()
      );

      pendingSubscriptionTrafficSources = { ...pendingSubscriptionTrafficSources };

      data.forEach((trafficSource) => {
        if (trafficSource.id) {
          delete pendingSubscriptionTrafficSources[trafficSource.id];
        }
      });

      context.commit("setPendingRequests", {
        ...context.rootState.pendingRequests,
        subscriptionTrafficSources: pendingSubscriptionTrafficSources,
      });

      context.commit("subscriptionsUploadTrafficSources", subscriptionTrafficSources, { root: true });
    }
  } catch (err) {
    return Promise.reject(err);
  }
};
